import React, { memo, useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './otpTimer.scss';

const OtpTimer = ({ expiredTime, onChange }) => {
  const [timer, setTimer] = useState(0);
  const [resend, setResend] = useState(false);

  useEffect(() => {
    setTimer(expiredTime);
  }, [expiredTime]);

  useEffect(() => {
    setTimer(expiredTime);
  }, [resend]);

  useEffect(() => {
    if (timer > 0) {
      const timeoutId = setTimeout(timeOutCallback, 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [timer, timeOutCallback, onChange]);

  const timeOutCallback = useCallback(() => {
    setTimer((currTimer) => currTimer - 1);
  }, []);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <>
      <div className="w-100 d-flex justify-content-center">
        {timer !== 0 && <span className="px-2">{formatTime(timer)}</span>}
        <div
          className={`${
            timer !== 0 ? 'disable text-third' : 'text-secondary cursor-pointer'
          }`}
          onClick={() => {
            if (timer === 0) {
              onChange(0);
              setResend(!resend);
            }
          }}
        >
          <FormattedMessage
            id={`user.${timer === 0 ? 'sendagain' : 'untilresend'}`}
          />
        </div>
      </div>
    </>
  );
};

export default memo(OtpTimer);
